import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-group-new',
  templateUrl: './vehicle-group-new.component.html',
  styleUrls: ['./vehicle-group-new.component.scss']
})
export class VehicleGroupNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
